/**
 * =============================================================================
 * AGENTIC TRIAGE REPORT TYPES
 * =============================================================================
 *
 * This file contains UI-specific types and enums for the Agentic Triage Report.
 *
 * IMPORTANT: For backend schema types (ConsolidatedEntityTriageReport, KeyFinding,
 * Evidence, etc.), import directly from @investigator/shared/generated/graphql
 *
 * This file only contains:
 * 1. UI-specific transformations (Action, AIAnalysisFinding, AIAnalysisArtifact)
 * 2. Frontend-only enums (RecommendedAction)
 *
 * =============================================================================
 */

/**
 * Recommended action type enum for type-safe action handling.
 * This enum is frontend-only for UI categorization.
 */
export enum RecommendedAction {
  IsolateEntity = 'isolate_entity',
  PreserveEvidence = 'preserve_evidence',
  BlockConnections = 'block_connections',
  SuppressEntity = 'suppress_entity',
}

/**
 * Action object for recommended responses UI
 * Transformed from backend's RecommendedActionsInfo
 */
export interface Action {
  type: RecommendedAction;
  description: string;
}

/**
 * Component-specific types for AIAnalysisPanel
 * These structures are created by the context provider's transformation logic
 */
export interface AIAnalysisFinding {
  id: string;
  content: Array<string | { artifactId: string }>;
}

export interface AIAnalysisArtifact {
  id: string;
  pattern?: RegExp | string; // RegExp for UI matching, string from backend API
  label: string;
  title: string;
  description: string;
  evidenceLink: string;
}
